export enum ShiftCategory {
    Days = 1,
    Nights = 2,
    DaysOrNights = 3,
}